import { FormActionsMui, FormActionsMuiRenderContainer } from '@app/components/form/FormActionsMui';
import { Box, Stack } from '@mui/material';

/**
 * Form actions for the create-fragment panel: Discard on the left,
 * Draft and Create on the right, with a spacer in between.
 */
const fragmentActionsLayout: FormActionsMuiRenderContainer = (leftActions, rightActions) => (
  <Stack direction="row" spacing={2} alignItems="center">
    {leftActions}
    <Box sx={{ flexGrow: 1 }} />
    {rightActions}
  </Stack>
);

type FragmentFormActionsProps = Parameters<typeof FormActionsMui>[0];

/**
 * Form actions component for the fragment creation panel.
 * Uses FormActionsMui with a custom layout: discard left, draft and create right.
 */
export function FragmentFormActions(props: FragmentFormActionsProps) {
  return <FormActionsMui variant="compact" {...props} renderContainer={fragmentActionsLayout} />;
}
